import { Stack, Text } from '@fairlo/ui-kit';
import { useTranslation } from 'react-i18next';
import marketingSiteRouteMap from '../../../../constants/marketingSiteRouteMap';
import Modal from '../../Modal';

const IdProtectTerms = () => {
  const { t } = useTranslation('Modal');

  return (
    <Modal title={t('IdProtectTerms.title')}>
      <Stack>
        <Text>Fairlo Personskydd passar dig som är privatperson och som.</Text>
        <Text>
          Du kan endast köpa Tjänsten om du
          <br />
          (i) är en fysisk person över 20 år,
          <br />
          (ii) har ett svenskt personnummer,
          <br />
          (iii) är folkbokförd i Sverige,
          <br />
          (iv) har ett bankkonto i en svensk bank,
          <br />
          (v) har ett personligt BankID samt
          <br />
          (vi) ansöker och beviljas Fairlos tjänst Fairlo Varda eller vid tidpunkten för köpet redan beviljats
          Fairlo Varda
          <br />
          Om det finns risk för obehörig användning måste du genast begära nytt lösenord.
        </Text>

        <div>
          <Text as="span" weight="bold">
            Pris och betalning
          </Text>
          <Text>Kostnaden för Tjänsten framgår vid köpetillfället.</Text>
        </div>

        <Text>
          Betalning sker genom autogiro den 25:e i varje månad. Om det saknas täckning kommer ytterligare
          dragningar att ske påföljande dagar och, om dragning fortfarande inte har kunnat ske, även vid den
          10:e i varje månad samt nästföljande månads dragning. Om förfallodagen inte infaller på en bankdag
          kommer autogirodragningen äga rum bankdagen innan förfallodagen. Det bankkonto som Du har anslutit
          debiteras på förfallodagen. Du måste ge ditt samtycke till att betalning sker genom autogiro. En
          förutsättning för att betalning ska kunna ske genom autogiro är att Din bank godkänner att Ditt
          anslutna bankkonto kan användas för betalning genom autogiro samt att Fairlo godkänner Dig som
          användare av tillämplig autogirotjänst.
        </Text>

        <Text>Om autogiro inte ansluts enligt ovan har Fairlo rätt att säga upp Tjänsten.</Text>

        <Text>
          Genom att klicka ”OK” bekräftar du att du har läst följande villkor för Fairlo Personskydd:{' '}
          <a href={marketingSiteRouteMap.idProtectTermsPdf} target="_blank" rel="noreferrer">
            Allmänna villkor
          </a>{' '}
          och{' '}
          <a href={marketingSiteRouteMap.integrity} target="_blank" rel="noreferrer">
            Integritetspolicy
          </a>
          ; Defentry:{' '}
          <a
            href="https://5004504.fs1.hubspotusercontent-na1.net/hubfs/5004504/Pdf%20documents/Defentry_TermsofUse_SE_220307.pdf"
            target="_blank"
            rel="noreferrer"
          >
            Användarvillkor
          </a>
          ; och Trygg-Hansa:{' '}
          <a
            href="https://5004504.fs1.hubspotusercontent-na1.net/hubfs/5004504/Tryg%20Insurance%20Terms/Forsakringsvillkor%20-Defentry%20-Trygghansa%20%20%20ID%20Protect%20Premium%20SE%2002350-1%20FINAL.pdf"
            target="_blank"
            rel="noreferrer"
          >
            Forsakringsvillkor
          </a>
          ,{' '}
          <a
            href="https://5004504.fs1.hubspotusercontent-na1.net/hubfs/5004504/Tryg%20Insurance%20Terms/ipid%20and%20f%C3%B6rk%C3%B6psinformation/Forkopsinformation%20-%20Defentry%20-Trygg%20hansa%20ID%20Protect%20Plus%20SE%2002351-1.pdf"
            target="_blank"
            rel="noreferrer"
          >
            Förköpsinformation
          </a>{' '}
          och{' '}
          <a
            href="https://5004504.fs1.hubspotusercontent-na1.net/hubfs/5004504/Tryg%20Insurance%20Terms/ipid%20and%20f%C3%B6rk%C3%B6psinformation/IPID%20Defentry%20ID%20Protect%20Premium%20SE%2002350-1.pdf"
            target="_blank"
            rel="noreferrer"
          >
            IPID
          </a>
          .
        </Text>
      </Stack>
    </Modal>
  );
};

export default IdProtectTerms;
